import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 导航树
export const setDigitalRoomNav: Mutation<IModuleState> = (state, payload) => {
  state.navigationTree.data = payload.data;
  state.navigationTree.loading = !!payload.loading;
};
